let userTimeZone:string=''
if (Intl) {
    userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export default userTimeZone
